import { render, staticRenderFns } from "./SupplierAccounts.vue?vue&type=template&id=e4e04fea"
import script from "./SupplierAccounts.vue?vue&type=script&lang=js"
export * from "./SupplierAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports